// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"UserCreatePanel_UsersInfoPanel__Z-gjl","buttonsPanel":"UserCreatePanel_buttonsPanel__MZa7m"};